import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0 20px;
`;

export const Info = styled.div`
  font-size: 20px;
  font-family: sans-serif;
  color: #5a7032;
`;
